import { React, useState, useEffect } from "react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DataTable from "examples/Tables/DataTable";
import AddIcon from "@mui/icons-material/Add";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Dropdown } from "semantic-ui-react";
import { ToastContainer, toast } from "react-toastify";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Select from "react-select";
import "../campus/Campus.css";
import { hasAdmissionPermission } from "hooks/permissions";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
/* React-Select Custom Styles */
const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "48px",
    fontSize: "16px",
    borderColor: state.isFocused ? "#1A73E8" : "#d2d6da",
    boxShadow: state.isFocused ? "0 0 0 2px #1A73E8" : null,
    "&:hover": {
      borderColor: "#1A73E8",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "16px",
    color: "#7b809a",
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: "16px",
    backgroundColor: state.isSelected
      ? "#1A73E8"
      : state.isFocused
      ? "#f8f9fa"
      : null,
    "&:active": {
      backgroundColor: "#1A73E8",
    },
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
};

const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

function EntryTests() {
  //Dialog Settings
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  //Variable Declarations

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [type, setType] = useState("");
  const [date, setDate] = useState("");
  const [total_score, setTotalScore] = useState("");
  const [location_type, setLocationType] = useState("");
  const [location, setLocation] = useState("");

  const [showViewTestModal, setShowViewTestModal] = useState(false);
  const [maxWidth, setMaxWidth] = useState("lg");
  const [fullWidth, setFullWidth] = useState(true);

  const [showDeleteEntryTestModal, setShowDeleteEntryTestModal] =
    useState(false);
  const [showAddEntryTestModal, setShowAddEntryTestModal] = useState(false);
  const [showUpdateEntryTestModal, setShowUpdateEntryTestModal] =
    useState(false);
  const [selectedEntryTest, setSelectedEntryTest] = useState(null);

  const [searchKeyword, setSearchKeyword] = useState("");
  const [all_entry_tests, setAllEntryTests] = useState([]);
  const [displayedEntryTests, setDisplayedEntryTests] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [selectedCampaignFilter, setSelectedCampaignFilter] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [selectedPrograms, setSelectedPrograms] = useState([]);

  const [formErrors, setFormErrors] = useState({
    title,
    description,
    type,
    date,
    total_score,
    location_type,
    location,
  });

  const [currentAppId, setCurrentAppId] = useState(null);

  const callErrors = (
    TITLE,
    DESCRIPTION,
    TYPE,
    DATE,
    TOTALSCORE,
    LOCATIONTYPE,
    LOCATION,
    CAMPAIGN,
    PROGRAMS
  ) => {
    const errors = {};
    if (TITLE === "") {
      errors.title = " * Title is Required";
    }
    if (DESCRIPTION === "") {
      errors.description = " * Description is Required";
    }
    if (TYPE === "") {
      errors.type = " * Please Select the Test Type";
    }
    if (DATE === "") {
      errors.date = " * Please Select the Date";
    }
    if (TOTALSCORE === "") {
      errors.total_score = " * Total Score is Required";
    }
    if (LOCATIONTYPE === "") {
      errors.location_type = " * Please Select the Location Type";
    }
    if (LOCATION === "") {
      errors.location = " * Location is Required";
    }
    if (!CAMPAIGN) {
      errors.campaign_id = " * Campaign is Required";
    }
    if (!PROGRAMS || PROGRAMS.length === 0) {
      errors.program_ids = " * At least one Program is Required";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSearchKeywordChange = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase();
    setSearchKeyword(searchTerm);

    if (searchTerm === "") {
      setDisplayedEntryTests(all_entry_tests);
      return;
    }

    let filteredEntryTests = all_entry_tests.filter((ent) => {
      const titleMatch = ent.title && ent.title.toLowerCase().includes(searchTerm);
      const typeMatch = ent.type && ent.type.toLowerCase().includes(searchTerm);
      const locationMatch = ent.location && ent.location.toLowerCase().includes(searchTerm);
      const dateMatch = ent.date && ent.date.toLowerCase().includes(searchTerm);
      const descriptionMatch =
        ent.description && ent.description.toLowerCase().includes(searchTerm);
      const totalScoreMatch =
        ent.total_score &&
        String(ent.total_score).toLowerCase().includes(searchTerm);

      return (
        titleMatch ||
        typeMatch ||
        locationMatch ||
        dateMatch ||
        descriptionMatch ||
        totalScoreMatch
      );
    });

    setDisplayedEntryTests(filteredEntryTests);
  };

  const handleFocus = (e) => {
    const { name } = e.target;

    setFormErrors((prevFormErrors) => ({
      ...prevFormErrors,
      [name]: "",
    }));
  };

  // GET Api calls
  const getEntryTestsByCampaign = async (campaignId) => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        campaign_ids: [campaignId],
      }),
    };

    await fetch(`${BASE_URL}/entrytest/get_entry_test_by_campaigns`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        const tests = data.entry_tests || [];
        setAllEntryTests(tests);
        setDisplayedEntryTests(tests);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Failed to fetch entry tests");
      });
  };

  const handleFetchEntryTests = async () => {
    if (!selectedCampaignFilter) {
      toast.error("Please select a campaign");
      return;
    }

    setSearchKeyword("");
    await getEntryTestsByCampaign(selectedCampaignFilter.value);
  };

  const refreshEntryTests = async () => {
    if (!selectedCampaignFilter) {
      setAllEntryTests([]);
      setDisplayedEntryTests([]);
      return;
    }
    await getEntryTestsByCampaign(selectedCampaignFilter.value);
  };

  // Fetch campaigns for dropdown
  const getCampaigns = async () => {
    try {
      const response = await fetch(`${BASE_URL}/campaign/get_campaigns`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      const formattedCampaigns = data.campaigns.map((campaign) => ({
        value: campaign.id,
        label: campaign.name,
      }));
      setCampaigns(formattedCampaigns);
    } catch (error) {
      console.error("Error fetching campaigns:", error);
      toast.error("Failed to fetch campaigns");
    }
  };

  // Fetch programs assigned to the selected campaign
  const getProgramsByCampaign = async (campaignId) => {
    if (!campaignId) {
      setPrograms([]);
      return [];
    }

    try {
      const response = await fetch(
        `${BASE_URL}/campaign/get_degrees_in_campaign/${campaignId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      const seen = new Set();
      const formattedPrograms = [];

      (data.degrees || []).forEach((degree) => {
        const programId = degree.degree_id || degree.program_id;
        if (!programId || seen.has(programId)) {
          return;
        }
        seen.add(programId);
        formattedPrograms.push({
          value: programId,
          label: degree.degree_name,
        });
      });

      setPrograms(formattedPrograms);
      return formattedPrograms;
    } catch (error) {
      console.error("Error fetching programs:", error);
      toast.error("Failed to fetch programs");
      setPrograms([]);
      return [];
    }
  };

  // Handle campaign selection
  const handleCampaignChange = async (selectedOption) => {
    setSelectedCampaign(selectedOption);
    setSelectedPrograms([]);
    if (selectedOption?.value) {
      await getProgramsByCampaign(selectedOption.value);
    } else {
      setPrograms([]);
    }
  };

  // Handle programs selection
  const handleProgramsChange = (selectedOptions) => {
    setSelectedPrograms(selectedOptions);
  };

  // Add Functions
  const showEntryTestAddModal = () => {
    setSelectedCampaign(null);
    setSelectedPrograms([]);
    setPrograms([]);
    setShowAddEntryTestModal(true);
  };

  const handleOkAddEntryTestModal = () => {
    if (
      title &&
      description &&
      type &&
      date &&
      total_score &&
      location_type &&
      location &&
      selectedCampaign &&
      selectedPrograms.length > 0
    ) {
      addEntryTest();
      setShowAddEntryTestModal(false);
    } else {
      callErrors(
        title,
        description,
        type,
        date,
        total_score,
        location_type,
        location,
        selectedCampaign,
        selectedPrograms
      );
    }
  };

  const handleCancelAddEntryTestModal = () => {
    setShowAddEntryTestModal(false);
    setTitle("");
    setDescription("");
    setType("");
    setDate("");
    setTotalScore("");
    setLocationType("");
    setLocation("");
    setSelectedCampaign(null);
    setSelectedPrograms([]);
    setPrograms([]);
    setFormErrors({
      title: "",
      description: "",
      type: "",
      date: "",
      total_score: "",
      location_type: "",
      location: "",
    });
  };

  const addEntryTest = async () => {
    let data = {
      title,
      description,
      type,
      date,
      total_score,
      location_type,
      location,
      campaign_id: selectedCampaign?.value,
      program_ids: selectedPrograms.map((prog) => prog.value),
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };

    await fetch(`${BASE_URL}/entrytest/add_entry_test`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        refreshEntryTests();
        toast.success("Entry Test Added Successfully");
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setTitle("");
        setDescription("");
        setType("");
        setDate("");
        setTotalScore("");
        setLocationType("");
        setLocation("");
        setSelectedCampaign(null);
        setSelectedPrograms([]);
        setPrograms([]);
      });
  };

  // Delete Functions

  const handleCancelDeleteEntryTestModal = () => {
    setShowDeleteEntryTestModal(false);
  };

  // Delete Functions
  const showEntryTestDeleteModal = (id) => {
    setCurrentAppId(id); // Set the currentAppId to the ID of the entry test to delete
    setShowDeleteEntryTestModal(true);
  };

  const handleOkDeleteEntryTestModal = () => {
    if (currentAppId) {
      deleteEntryTest();
      setShowDeleteEntryTestModal(false);
    } else {
      console.error("No App ID set for deletion.");
    }
  };

  const deleteEntryTest = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(
      `${BASE_URL}/entrytest/delete_entry_test/${currentAppId}`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        refreshEntryTests();
        toast.success("Entry Test Deleted Successfully");
      })
      .catch((error) => console.error("Error deleting entry test:", error));
  };

  // Update Functions
  const showEntryTestUpdateModal = async (id) => {
    const entryTestToUpdate = all_entry_tests.find((test) => test.id === id);
    if (entryTestToUpdate) {
      // Set all the form fields
      setTitle(entryTestToUpdate.title);
      setDescription(entryTestToUpdate.description);
      setType(entryTestToUpdate.type);
      setDate(entryTestToUpdate.date);
      setTotalScore(entryTestToUpdate.total_score);
      setLocationType(entryTestToUpdate.location_type);
      setLocation(entryTestToUpdate.location);
      
      // Set campaign selection
      const campaignOption = campaigns.find(c => c.value === entryTestToUpdate.campaign_id);
      setSelectedCampaign(campaignOption);

      const campaignPrograms = await getProgramsByCampaign(entryTestToUpdate.campaign_id);
      const programOptions = campaignPrograms.filter(p => 
        entryTestToUpdate.program_ids && entryTestToUpdate.program_ids.includes(p.value)
      );
      setSelectedPrograms(programOptions);

      setSelectedEntryTest(entryTestToUpdate);
      setShowUpdateEntryTestModal(true);
    } else {
      console.error("Entry test not found for ID:", id);
      toast.error("Failed to load entry test data");
    }
  };

  const handleOkUpdateEntryTestModal = () => {
    if (
      title &&
      description &&
      type &&
      date &&
      total_score &&
      location_type &&
      location &&
      selectedCampaign &&
      selectedPrograms.length > 0
    ) {
      updateEntryTest();
      setShowUpdateEntryTestModal(false);
    } else {
      callErrors(
        title,
        description,
        type,
        date,
        total_score,
        location_type,
        location,
        selectedCampaign,
        selectedPrograms
      );
    }
  };

  const handleCancelUpdateEntryTestModal = () => {
    setShowUpdateEntryTestModal(false);
    setTitle("");
    setDescription("");
    setType("");
    setDate("");
    setTotalScore("");
    setLocationType("");
    setLocation("");
    setSelectedCampaign(null);
    setSelectedPrograms([]);
    setPrograms([]);
    setFormErrors({
      title: "",
      description: "",
      type: "",
      date: "",
      total_score: "",
      location_type: "",
      location: "",
    });
  };

  const updateEntryTest = async () => {
    if (selectedEntryTest) {
      let data = {
        id: selectedEntryTest.id,
        title,
        description,
        type,
        date,
        total_score,
        location_type,
        location,
        campaign_id: selectedCampaign?.value,
        program_ids: selectedPrograms.map(prog => prog.value)
      };

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      };
      await fetch(`${BASE_URL}/entrytest/update_entry_test`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          refreshEntryTests();
          toast.success("Entry Test Updated Successfully");
        })
        .catch((error) => console.log(error))
        .finally(() => {
          setTitle("");
          setDescription("");
          setType("");
          setDate("");
          setTotalScore("");
          setLocationType("");
          setLocation("");
          setSelectedCampaign(null);
          setSelectedPrograms([]);
          setPrograms([]);
        });
    }
  };

  const viewTest = (id) => {
    const test = all_entry_tests.find((d) => d.id === id);
    setSelectedEntryTest(test);
    setShowViewTestModal(true);
  };

  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Title", accessor: "title", align: "left" },
    { Header: "Type", accessor: "type", align: "center" },
    { Header: "Location", accessor: "location", align: "center" },
    { Header: "Date", accessor: "date", align: "center" },
    { Header: "Total Score", accessor: "total_score", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ];

  const rows =
    displayedEntryTests.length > 0
      ? displayedEntryTests.map((ent, index) => {
          return {
            serial: index + 1,
            title: ent.title,
            type: ent.type,
            location: ent.location,
            date: ent.date,
            total_score: ent.total_score,
            actions: (
              <>
                 {hasAdmissionPermission('Entry Tests','UPDATE') && (
                <IconButton onClick={() => showEntryTestUpdateModal(ent.id)}>
                  <EditIcon style={{ color: "green" }} />
                </IconButton>
                 )}
                 {hasAdmissionPermission('Entry Tests','READ') && (
                <IconButton onClick={() => viewTest(ent.id)}>
                  <VisibilityOutlinedIcon className="icon-button-view" />
                </IconButton>
                 )}
                 {hasAdmissionPermission('Entry Tests','DELETE') && (
                <IconButton onClick={() => showEntryTestDeleteModal(ent.id)}>
                  <DeleteIcon style={{ color: "red" }} />
                </IconButton>
                 )}
                 {hasAdmissionPermission('Entry Tests','MANAGE') && (
                <IconButton onClick={() => 
                    window.open(`${BASE_URL}/entrytest/export_entry_test_applications_csv/${ent.id}`, "_blank")
                }>
                  <FileDownloadIcon style={{ color: "green" }} />
                </IconButton>
                 )}
              </>
            ),
          };
        })
      : [
          {
            serial: null,
            title: null,
            campaign: null,
            type: null,
            location: null,
            date: null,
            description: null,
            total_score: null,
            actions: null,
          },
        ];

  // Initial Renderings
  useEffect(() => {
    getCampaigns();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card className="mt-5 card1">
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={1}
                  sx={{ width: "100%" }}
                >
                  <Stack direction="row" spacing={1} sx={{ minWidth: "350px" }}>
                    <Select
                      value={selectedCampaignFilter}
                      onChange={setSelectedCampaignFilter}
                      options={campaigns}
                      className="basic-select"
                      classNamePrefix="select"
                      placeholder="Select Campaign"
                      styles={customSelectStyles}
                      menuPortalTarget={document.body}
                    />
                    <Button
                      variant="contained"
                      onClick={handleFetchEntryTests}
                      style={{ color: "#fff" }}
                    >
                      Fetch
                    </Button>
                  </Stack>
                  <Stack sx={{ flexGrow: 1 }}>
                    <Paper component="form" className="search-paper">
                      <InputBase
                        sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                        placeholder="Search"
                        inputProps={{ "aria-label": "search voucher" }}
                        value={searchKeyword}
                        onChange={handleSearchKeywordChange}
                      />
                      <SearchIcon className="search-icon" />
                    </Paper>
                  </Stack>
                  {hasAdmissionPermission('Entry Tests','CREATE') && (
                  <Button
                    variant="outlined"
                    endIcon={<AddIcon className="add-icon" />}
                    onClick={showEntryTestAddModal}
                    className="add-full-button"
                  >
                    Create new
                  </Button>
                  )}
                </Stack>
              </MDBox>
              <MDBox pt={3}>
                {displayedEntryTests && displayedEntryTests.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src="nodata.png"
                      style={{
                        display: "block",
                        margin: "auto",
                        width: "20%",
                        height: "20%",
                      }}
                    />
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Add Dialog */}
      <Dialog
        fullScreen={fullScreen}
        // maxWidth={maxWidth}
        open={showAddEntryTestModal}
        onClose={handleCancelAddEntryTestModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
        // fullWidth
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-title">
          {"Create Entry Test"}
        </DialogTitle>
        <DialogContent className="dialog-content">
          <div className="row">
            <div className="col-md-6 left-fields">
              <div className="form-outline mt-3">
                <label>Campaign</label>
                <Select
                  value={selectedCampaign}
                  onChange={handleCampaignChange}
                  options={campaigns}
                  className="basic-select"
                  classNamePrefix="select"
                  placeholder="Select Campaign"
                  styles={customSelectStyles}
                />
                {formErrors.campaign_id && (
                  <div className="error-message1">{formErrors.campaign_id}</div>
                )}
              </div>

              <div className="form-outline mt-3">
                <label>Title</label>
                <input
                  name="title"
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  className="form-control form-control-lg"
                  placeholder="Enter Title"
                />
                {formErrors.title && (
                  <div className="error-message1">{formErrors.title}</div>
                )}
              </div>
            </div>

            <div className="col-md-6 form-sideline">
              <div className="form-outline mt-3">
                <label>Programs</label>
                <Select
                  isMulti
                  value={selectedPrograms}
                  onChange={handleProgramsChange}
                  options={programs}
                  isDisabled={!selectedCampaign}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder={
                    selectedCampaign
                      ? "Select Programs"
                      : "Select Campaign first"
                  }
                  styles={customSelectStyles}
                />
                {formErrors.program_ids && (
                  <div className="error-message">{formErrors.program_ids}</div>
                )}
              </div>

              <div className="form-outline mt-3">
                <label>Type</label>
                <Dropdown
                  id="type"
                  name="type"
                  placeholder="Select Test Type "
                  fluid
                  selection
                  value={type}
                  onChange={(e, { value }) => setType(value)}
                  options={[
                    {
                      key: "",
                      text: "",
                      value: "",
                    },
                    {
                      key: "1",
                      text: "General",
                      value: "General",
                    },
                    {
                      key: "2",
                      text: "Engineering",
                      value: "Engineering",
                    },
                    {
                      key: "3",
                      text: "Medical",
                      value: "Medical",
                    },
                    {
                      key: "4",
                      text: "Short Course",
                      value: "Short Course",
                    },
                  ]}
                  className="custom-dropdown"
                />
                <div className="error-message1">{formErrors.type}</div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Test Date & Time</label>
                <input
                  type="datetime-local"
                  name="test_date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
              <div className="error-message1">{formErrors.date}</div>
            </div>

            <div className="col-md-6">
              <div className="mt-3">
                <label>Location Type</label>
                <Dropdown
                  id="location_type"
                  name="location_type"
                  placeholder="Select Location Type "
                  fluid
                  selection
                  value={location_type}
                  onChange={(e, { value }) => setLocationType(value)}
                  options={[
                    {
                      key: "",
                      text: "",
                      value: "",
                    },
                    {
                      key: "1",
                      text: "Physical",
                      value: "Physical",
                    },
                    {
                      key: "2",
                      text: "Virtual Link",
                      value: "Virtual Link",
                    },
                  ]}
                  className="custom-dropdown"
                />
                <div className="error-message">{formErrors.location_type}</div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Total Score</label>
                <input
                  name="total_score"
                  type="number"
                  value={total_score}
                  onChange={(e) => setTotalScore(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Total Score"
                />
              </div>
              <div className="error-message1">{formErrors.total_score}</div>
            </div>

            <div className="col-md-6">
              <div className="mt-3">
                <label>Location</label>
                <input
                  name="location"
                  type="text"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Location"
                />
              </div>
              <div className="error-message">{formErrors.location}</div>
            </div>

            <div className="col-md-12">
              <div className="form-outline mt-3">
                <label>Description</label>
                <ReactQuill
                  value={description}
                  onChange={(content) => setDescription(content)}
                  className="custom-quill"
                  placeholder="Enter Entry Test Description"
                  modules={{
                    toolbar: [
                      ['bold', 'italic', 'underline', 'strike'],
                      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                      ['link'],
                      ['clean']
                    ]
                  }}
                />
              </div>
              <div className="error-message1">{formErrors.description}</div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={handleCancelAddEntryTestModal}
          >
            Close
          </Button>
          <Button
            className="dialog-actions-button positive"
            onClick={handleOkAddEntryTestModal}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog
        fullScreen={fullScreen}
        maxWidth={maxWidth}
        open={showDeleteEntryTestModal}
        onClose={handleCancelDeleteEntryTestModal}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{
          sx: {
            width: "450px",
            borderRadius: "20px",
            opacity: 1,
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-delete">
          {"Delete Entry Test"}
        </DialogTitle>
        <DialogContent className="content-delete">
          <DialogContentText>
            Are you sure to delete this Entry Test?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={handleCancelDeleteEntryTestModal}
          >
            Cancel
          </Button>
          <Button
            className="dialog-actions-button positive"
            onClick={handleOkDeleteEntryTestModal}
          >
            Done
          </Button>
        </DialogActions>
      </Dialog>

      {/* Update Dialog */}
      <Dialog
        open={showUpdateEntryTestModal}
        onClose={() => setShowUpdateEntryTestModal(false)}
        maxWidth="lg"
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle className="dialog-title">Update Entry Test</DialogTitle>
        <DialogContent className="dialog-content">
          <div className="row">
            <div className="col-md-6 left-fields">
              <div className="form-outline mt-3">
                <label>Campaign</label>
                <Select
                  value={selectedCampaign}
                  onChange={handleCampaignChange}
                  options={campaigns}
                  className="basic-select"
                  classNamePrefix="select"
                  placeholder="Select Campaign"
                  styles={customSelectStyles}
                />
                {formErrors.campaign_id && (
                  <div className="error-message1">{formErrors.campaign_id}</div>
                )}
              </div>

              <div className="form-outline mt-3">
                <label>Title</label>
                <input
                  name="title"
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  className="form-control form-control-lg"
                  placeholder="Enter Title"
                />
                {formErrors.title && (
                  <div className="error-message1">{formErrors.title}</div>
                )}
              </div>
            </div>

            <div className="col-md-6 form-sideline">
              <div className="form-outline mt-3">
                <label>Programs</label>
                <Select
                  isMulti
                  value={selectedPrograms}
                  onChange={handleProgramsChange}
                  options={programs}
                  isDisabled={!selectedCampaign}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder={
                    selectedCampaign
                      ? "Select Programs"
                      : "Select Campaign first"
                  }
                  styles={customSelectStyles}
                />
                {formErrors.program_ids && (
                  <div className="error-message">{formErrors.program_ids}</div>
                )}
              </div>

              <div className="form-outline mt-3">
                <label>Type</label>
                <Dropdown
                  id="type"
                  name="type"
                  placeholder="Select Test Type "
                  fluid
                  selection
                  value={type}
                  onChange={(e, { value }) => setType(value)}
                  options={[
                    {
                      key: "",
                      text: "",
                      value: "",
                    },
                    {
                      key: "1",
                      text: "General",
                      value: "General",
                    },
                    {
                      key: "2",
                      text: "Engineering",
                      value: "Engineering",
                    },
                    {
                      key: "3",
                      text: "Medical",
                      value: "Medical",
                    },
                    {
                      key: "4",
                      text: "Short Course",
                      value: "Short Course",
                    },
                  ]}
                  className="custom-dropdown"
                />
                <div className="error-message1">{formErrors.type}</div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Test Date & Time</label>
                <input
                  type="datetime-local"
                  name="test_date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
              <div className="error-message1">{formErrors.date}</div>
            </div>

            <div className="col-md-6">
              <div className="mt-3">
                <label>Location Type</label>
                <Dropdown
                  id="location_type"
                  name="location_type"
                  placeholder="Select Location Type "
                  fluid
                  selection
                  value={location_type}
                  onChange={(e, { value }) => setLocationType(value)}
                  options={[
                    {
                      key: "",
                      text: "",
                      value: "",
                    },
                    {
                      key: "1",
                      text: "Physical",
                      value: "Physical",
                    },
                    {
                      key: "2",
                      text: "Virtual Link",
                      value: "Virtual Link",
                    },
                  ]}
                  className="custom-dropdown"
                />
                <div className="error-message">{formErrors.location_type}</div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Total Score</label>
                <input
                  name="total_score"
                  type="number"
                  value={total_score}
                  onChange={(e) => setTotalScore(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Total Score"
                />
              </div>
              <div className="error-message1">{formErrors.total_score}</div>
            </div>

            <div className="col-md-6">
              <div className="mt-3">
                <label>Location</label>
                <input
                  name="location"
                  type="text"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Location"
                />
              </div>
              <div className="error-message">{formErrors.location}</div>
            </div>

            <div className="col-md-12">
              <div className="form-outline mt-3">
                <label>Description</label>
                <ReactQuill
                  value={description}
                  onChange={(content) => setDescription(content)}
                  className="custom-quill"
                  placeholder="Enter Entry Test Description"
                  modules={{
                    toolbar: [
                      ['bold', 'italic', 'underline', 'strike'],
                      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                      ['link'],
                      ['clean']
                    ]
                  }}
                />
              </div>
              <div className="error-message1">{formErrors.description}</div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={() => setShowUpdateEntryTestModal(false)}
          >
            Close
          </Button>
          <Button
            className="dialog-actions-button positive"
            onClick={handleOkUpdateEntryTestModal}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Dialog */}
      <Dialog
        open={showViewTestModal}
        onClose={() => setShowViewTestModal(false)}
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-delete">
          View Batch
        </DialogTitle>
        <DialogContent className="dialog-content">
          {selectedEntryTest && (
            <>
              <div className="flex-container">
                <strong className="label1">Name</strong>
                <span className="value1">{selectedEntryTest.type}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Year</strong>
                <span className="value1">{selectedEntryTest.title}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Type</strong>
                <span className="value1">{selectedEntryTest.date}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Batch Code</strong>
                <span className="value1">
                  {selectedEntryTest.location_type}
                </span>
              </div>
              <div className="flex-container">
                <strong className="label1">Start Date</strong>
                <span className="value1">
                  {new Date(selectedEntryTest.total_score).toLocaleDateString()}
                </span>
              </div>
              <div className="flex-container">
                <strong className="label1">End Date</strong>
                <span className="value1">
                  {new Date(selectedEntryTest.location).toLocaleDateString()}
                </span>{" "}
              </div>
              <div className="flex-container">
                <strong className="label1">Status</strong>
                <span className="value1">{selectedEntryTest.description}</span>
              </div>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={() => setShowViewTestModal(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default EntryTests;
